/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link } from 'react-router-dom'
import logo from '../../assets/logo.png'
import '../Header/styles.css'

export function MainHeader() {
  return (
    <header className="Menu">
        <div className="logoHeader">
          <Link to="/">
          <img src={logo} alt="Busca Saúde" />
          </Link>

          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"><i className="fas fa-bars"></i></span>
            </button>
        </div> 
         
          <nav className="navbar navbar-expand-lg">
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <Link className="nav-link active" aria-current="page" to="/">HOME</Link>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/#faq">FAQ</a>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/termos-de-uso">TERMOS DE USO</Link>
                </li>
                <li className="nav-item">
                  <a className="nav-link" target={"_blank"} href="https://api.whatsapp.com/send?phone=5537999833954&text=Olá, estou entrando em contato pelo site do Busca Saúde..." rel="noreferrer">CONTATO</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/register">QUERO FAZER PARTE</a>
                </li>
              </ul>
            </div>
          </nav>
    </header>
  )
}